export const navigationItems = [
  {
    label: "for.caregivers",
    items: [
      { label: "caregiver.services", href: "/caregiver-1/" },
      { label: "caregiver.normal", href: "/caregiver-normal/" },
      { label: "caregiver.24", href: "/caregiver-24h/" },
    ],
  },
  {
    label: "careseeker.families",
    items: [
      { label: "careseeker.services", href: "/careseeker-services/" },
      { label: "careseeker.normal", href: "/careseeker-normal/" },
      { label: "careseeker.24", href: "/careseeker-24h/" },
    ],
  },
  {
    label: "companies",
    items: [
      { label: "companies.services", href: "/company-services/" },
      { label: "companies.caregivers", href: "/company-caregivers/" },
      { label: "social.impact", href: "/company-social-impact/" },
    ],
  },
];

export const faqs = [
  {
    id: 1,
    question: "caregiver.faq.how-matching-system-works.question",
    answer: "caregiver.faq.how-matching-system-works.answer",
  },
  {
    id: 2,
    question: "caregiver.faq.register-as-self-employed-caregiver.question",
    answer: "caregiver.faq.register-as-self-employed-caregiver.answer",
  },
  {
    id: 3,
    question: "caregiver.faq.rights-and-duties.question",
    answer: "caregiver.faq.rights-and-duties.answer",
  },
  {
    id: 4,
    question: "caregiver.faq.find-right-caregiver.question",
    answer: "caregiver.faq.find-right-caregiver.answer",
  },
  {
    id: 5,
    question: "caregiver.faq.cost-of-24-hour-caregiver.question",
    answer: "caregiver.faq.cost-of-24-hour-caregiver.answer",
  },
];

export const careseekerFAQ = [
  {
    id: 1,
    question: "careseeker.faq.how-matching-system-works.question",
    answer: "careseeker.faq.how-matching-system-works.answer",
  },
  {
    id: 2,
    question: "careseeker.faq.choosing-caregiver-considerations.question",
    answer: "careseeker.faq.choosing-caregiver-considerations.answer",
  },
  {
    id: 3,
    question: "careseeker.faq.twenty-four-hour-cost.question",
    answer: "careseeker.faq.twenty-four-hour-cost.answer",
  },
  {
    id: 4,
    question: "careseeker.faq.changing-caregivers.question",
    answer: "careseeker.faq.changing-caregivers.answer",
  },
  {
    id: 5,
    question: "careseeker.faq.careseeker-rights.question",
    answer: "careseeker.faq.careseeker-rights.answer",
  },
];
